'use client'
import { Button } from '@/components/Button'
import basketIcon from '../../../public/basket.svg'
import Image from 'next/image'
import clsx from 'clsx'
import { useContext, useMemo } from 'react'
import { BasketContext } from '../BasketProvider'

interface Props {
    className?: string
}

export default function NavbarBasketButton({ className }: Props) {
    const { products } = useContext(BasketContext)
    const total = useMemo(() => products.length, [products])
    return (
        <Button
            rootClasses={clsx('indicator px-8', className)}
            color="secondary"
            url="/eshop/basket"
            testId="basketButton"
        >
            {total > 0 && (
                <span className="indicator-item badge bg-orange text-white px-1.5 indicator-bottom">
                    {total > 99 ? '99+' : total}
                </span>
            )}
            <Image src={basketIcon} alt="basket" />
        </Button>
    )
}
